// Formatação do simulador de bonificação: a mesma do simulador do site
// (vigorenergy.com.br/parceiros) — percentual com até 1 casa, centavo com sinal de menos tipográfico.

const brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const brl0 = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
const n0 = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 });
const p1 = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 });
const p2 = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const reais = (v: number) => brl.format(v).replace('-', '−');
export const reais0 = (v: number) => brl0.format(v);
export const kwh = (v: number) => n0.format(v);
export const mil = (v: number) => `${p1.format(v / 1000)} mil`;
export const pc = (x: number) => `${p1.format(Math.round(x * 1e6) / 1e4)}%`;
export const pc2 = (x: number) => `${p2.format(Math.round(x * 1e6) / 1e4)}%`;

/** Consumo digitado: só o número inteiro de kWh ("4.000", "4000 kWh" e "4000,5" viram 4000). */
export function lerConsumo(s: string): number {
  const inteiro = s.split(',')[0].replace(/\D/g, '');
  return inteiro ? Number(inteiro) : NaN;
}
